import { render } from "./ButtonInertiaLink.vue?vue&type=template&id=895e886c"
import script from "./ButtonInertiaLink.vue?vue&type=script&lang=js"
export * from "./ButtonInertiaLink.vue?vue&type=script&lang=js"

import exportComponent from "/Users/valdisaglonietis/PhpstormProjects/news_site/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ButtonInertiaLink.vue"]])

export default __exports__